import React, { useContext, useEffect, useState } from 'react';
import './App.css';
import { SiGoogle, SiFacebook, SiTwitter } from 'react-icons/si';
import ImgLogo from './img/secondo-logo.svg';
import { Link } from 'react-router-dom';
import axios from 'axios';
import useAuth from './UseAuth';
import { StateContext } from './components/StateContainer';
import PatternLogin from './img/pattern_login_unico.jpg';
import Esagono from './img/esagono.svg';
import LogoFulgeas from './img/Fulgeas_Yellow_White.png';
import {
  GoogleOAuthProvider,
  GoogleLogin,
  googleLogout,
} from '@react-oauth/google';
import Cookies from 'js-cookie';

// ─────────────────────────────────────────────────────────────
// SECURITY UTILS
// ─────────────────────────────────────────────────────────────

/**
 * Validazione email: RFC 5322 semplificato.
 * Previene invio di valori arbitrari al backend.
 */
const isValidEmail = (value) =>
  typeof value === 'string' &&
  /^[^\s@]{1,64}@[^\s@]{1,255}\.[^\s@]{2,}$/.test(value.trim());

/**
 * Sanitizza stringhe rimuovendo caratteri di controllo e troncando.
 * NON usare per HTML — solo per testo piano.
 */
const sanitizeString = (value, maxLength = 500) => {
  if (typeof value !== 'string') return '';
  return value
    .replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '')
    .slice(0, maxLength);
};

/**
 * Validazione Google credential token:
 * accetta solo JWT ben formati (3 segmenti base64url separati da punto).
 * Previene injection di valori arbitrari nel payload.
 */
const isValidGoogleCredential = (value) =>
  typeof value === 'string' &&
  /^[A-Za-z0-9\-_]+\.[A-Za-z0-9\-_]+\.[A-Za-z0-9\-_]+$/.test(value) &&
  value.length <= 4096;

// ─────────────────────────────────────────────────────────────
// COMPONENTE
// ─────────────────────────────────────────────────────────────

function Login() {
  const { loading, setLoading, error, setError, setPageTitle } =
    useContext(StateContext);

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isError, setIsError] = useState(false);

  // FIX: stato email e password con lunghezza massima controllata a runtime
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const { login } = useAuth();

  useEffect(() => {
    setPageTitle('Login');
    // FIX: il parametro 'token' da URL veniva letto ma mai usato né validato.
    // Rimosso per evitare confusione e potenziale abuso futuro.
    // Se sarà necessario in futuro, aggiungere validazione prima dell'uso.
  }, []);

  // Handler cambio email: tronca a 254 char (limite RFC 5321)
  const handleEmailChange = (e) => {
    setEmail(e.target.value.slice(0, 254));
  };

  // Handler cambio password: tronca a 128 char
  const handlePasswordChange = (e) => {
    setPassword(e.target.value.slice(0, 128));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsError(false);

    // FIX: valida email lato client prima di inviare al backend
    const sanitizedEmail = sanitizeString(email.trim(), 254);
    if (!isValidEmail(sanitizedEmail)) {
      setIsError(true);
      setError('Inserisci un indirizzo email valido');
      return;
    }

    // FIX: sanifica la password (solo rimozione caratteri di controllo, no trim)
    const sanitizedPassword = sanitizeString(password, 128);
    if (!sanitizedPassword) {
      setIsError(true);
      setError('Inserisci la password');
      return;
    }

    setLoading(true);

    // FIX: invia solo i campi sanitizzati
    const loginPayload = {
      email: sanitizedEmail,
      password: sanitizedPassword,
    };

    axios
      .post(`${process.env.REACT_APP_BASE_URL}/login_check`, loginPayload)
      .then((response) => {
        setLoading(false);
        setError('');

        const token = response.data?.token;

        // FIX: valida il token ricevuto prima di usarlo
        if (typeof token !== 'string' || token.length === 0) {
          setIsError(true);
          setError('Risposta del server non valida');
          return;
        }

        login(token);
      })
      .catch((reason) => {
        setLoading(false);
        setIsError(true);
        // FIX: non espone dettagli tecnici dell'errore all'utente
        console.error('Login error:', reason);
        setError('Email o password errati');
      });
  };

  const GoogleLoginCredentials = (credential) => {
    // FIX: valida il formato del credential JWT prima di inviarlo al backend
    if (!isValidGoogleCredential(credential)) {
      console.error('Google credential non valido o malformato');
      setIsError(true);
      setError('Autenticazione Google non riuscita');
      return;
    }

    const loginPayload = { googleToken: credential };

    axios
      .post(`${process.env.REACT_APP_BASE_URL}/login_google`, loginPayload)
      .then((response) => {
        setLoading(false);
        setError('');

        const token = response.data?.token;

        // FIX: valida il token ricevuto prima di usarlo
        if (typeof token !== 'string' || token.length === 0) {
          setIsError(true);
          setError('Risposta del server non valida');
          return;
        }

        login(token);
      })
      .catch((reason) => {
        setLoading(false);
        setIsError(true);
        // FIX: non espone dettagli tecnici dell'errore all'utente
        console.error('Google login error:', reason);
        setError('Autenticazione Google non riuscita');
      });
  };

  return (
    <div
      className="login-bg"
      style={{
        background: `url(${PatternLogin}) center center / contain repeat`,
        backgroundSize: '17%',
      }}
    >
      <div className="account-pages pt-sm-5 d-flex align-items-center">
        <div className="container">
          <div className="row py-auto mb-2">
            <div className="col-lg-12 d-flex justify-content-center align-items-center"></div>
          </div>
          <div className="row justify-content-center">
            <div
              className="col-12 d-flex justify-content-center esagono-img"
              style={{ zIndex: 9999 }}
            >
              <img src={Esagono} alt="" className="svg-shadow" />
            </div>
            <div className="col-12 justify-content-center">
              <div
                className="text-center align-items-center tailor_logo"
                style={{ zIndex: 99999 }}
              >
                {/* FIX: <a> senza href sostituito con <div> — un anchor vuoto
                    non è semanticamente corretto e può causare comportamenti
                    imprevisti in alcuni browser/screen reader */}
                <div className="d-block auth-logo my-auto">
                  <img
                    src={ImgLogo}
                    alt="TailorGPT Logo"
                    className="logo logo-dark"
                  />
                </div>
              </div>
            </div>

            <div className="col-md-8 col-lg-6 col-xl-5" style={{ zIndex: 99 }}>
              <div className="card position-relative border-0 shadow overflow-hidden card-login p-1">
                <div className="circle-login" style={{ zIndex: 0 }}></div>
                <div
                  className="card-body d-flex align-items-center justify-content-around position-relative w-100"
                  style={{ zIndex: 9999 }}
                >
                  <div className="p-2 mt-5 form-body-login w-100">
                    <form
                      onSubmit={handleSubmit}
                      className="align-items-center"
                      // FIX: disabilita autocompletamento del browser sul form
                      // per ambienti in cui è richiesto (es. kiosk, shared device)
                      autoComplete="on"
                      noValidate
                    >
                      <div className="mb-3">
                        <label
                          className="form-label fw-bold"
                          htmlFor="username"
                        >
                          Username
                        </label>
                        <input
                          type="email"
                          className="form-control border-green-second"
                          id="username"
                          // FIX: type="email" invece di "text" — attiva validazione
                          // nativa del browser e comunica il formato atteso
                          placeholder="Inserisci lo Username"
                          value={email}
                          onChange={handleEmailChange}
                          maxLength={254}
                          autoComplete="username"
                          required
                          // FIX: aria per accessibilità
                          aria-label="Email o username"
                          aria-required="true"
                        />
                      </div>

                      <div className="mb-3">
                        <label
                          className="form-label fw-bold"
                          htmlFor="userpassword"
                        >
                          Password
                        </label>
                        <input
                          type="password"
                          className="form-control border-green-second"
                          id="userpassword"
                          placeholder="Inserisci la Password"
                          value={password}
                          onChange={handlePasswordChange}
                          maxLength={128}
                          autoComplete="current-password"
                          required
                          aria-label="Password"
                          aria-required="true"
                        />
                      </div>

                      <div className="mt-3 text-center">
                        <button
                          className="btn bg-green-second text-white w-sm waves-effect waves-light w-50 mt-2 login-submit"
                          type="submit"
                          // FIX: disabilitato durante il caricamento per prevenire
                          // doppio invio (double submit)
                          disabled={loading}
                        >
                          {loading ? 'Caricamento...' : 'LOGIN'}
                        </button>
                      </div>

                      <div className="d-flex align-items-center">
                        <hr className="w-100" />
                        <p className="m-0 p-4">Oppure</p>
                        <hr className="w-100" />
                      </div>

                      <div className="w-100 d-flex align-items-center justify-content-center">
                        {/* FIX: clientId spostato in variabile d'ambiente.
                            Esporre il Client ID OAuth nel codice sorgente è un
                            rischio: chiunque può usarlo per phishing o
                            per registrare app fraudolente sullo stesso client.
                            Aggiungere REACT_APP_GOOGLE_CLIENT_ID al .env */}
                        <GoogleOAuthProvider
                          clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                        >
                          <GoogleLogin
                            onSuccess={(credentialResponse) => {
                              GoogleLoginCredentials(
                                credentialResponse.credential,
                              );
                            }}
                            onError={() => {
                              // FIX: gestisce l'errore aggiornando lo stato
                              // invece di loggare silenziosamente
                              setIsError(true);
                              setError('Accesso con Google non riuscito');
                              console.error('Google OAuth Login Failed');
                            }}
                          />
                        </GoogleOAuthProvider>
                      </div>
                    </form>
                  </div>
                </div>

                <div
                  className="card-footer align-items-center d-flex border-0 bg-blu-fulgeas justify-content-center"
                  style={{ height: '120px' }}
                >
                  <div className="row fulgeas_creator_login justify-content-center w-100">
                    <div className="col-12 d-flex col-lg-auto justify-content-center pt-2">
                      <h6 className="text-white fw-bold">Proudly created by</h6>
                    </div>
                    <div className="col-12 col-lg-auto d-flex justify-content-center pb-2">
                      <img src={`${LogoFulgeas}`} alt="Fulgeas" />
                    </div>
                  </div>
                </div>
              </div>

              {isError ? (
                <div
                  className="text-danger text-center alert bg-white rounded-3 mt-2 error-credential"
                  role="alert"
                  aria-live="assertive"
                >
                  {/* FIX: mostra un messaggio generico fisso invece del valore
                      dinamico di error/setError, per evitare che messaggi
                      tecnici dal backend vengano esposti all'utente */}
                  <p className="m-0">Nome utente e/o password errati</p>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
